export const API_KEY = "afd52b9f0d1bbaa29d4ae34ef1bb7d2f";
export const SEARCH_URL = "https://api.openweathermap.org/data/2.5/weather?q=Vancouver,ca&appid=";
export const URL = "https://api.openweathermap.org/data/2.5/weather?q=";
export const ICON_URL = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/162656/"